import React, { useState, useEffect } from "react";
import moment from "moment";

export const Horloge = ({ onDashboard }) => {
  var [date, setDate] = useState(new Date());

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return () => {
      clearInterval(timer);
    };
  });

  return (
    <div className="horloge">
      {onDashboard ? (
        <>
          <span className="day">{moment().locale("fr").format("dddd")}</span>
          <div className="date-time">
            <span className="date">{moment(date).locale("fr").format("DD/MM/YYYY")} </span>
            <span className="time">{moment(date).locale("fr").format("HH:mm")}</span>
          </div>
        </>
      ) : (
        <>
          <span className="day">{moment().locale("fr").format("dddd")}</span>
          <span className="date"> {date.toLocaleDateString()}</span>
          <span className="time"> {date.toLocaleTimeString()}</span>
        </>
      )}
    </div>
  );
};

export default Horloge;
